export default __webpack_public_path__ + "static/SuisseIntl-Medium-592edebd0320607f065adda986f05c7b.woff2";